import { assertAPIResponse } from "../../services/api-response";
import axiosInstance from "../../services/axiosInstance";
import handleAPIError, {
  MESSAGE_CODES,
  showSuccessToast,
} from "../../services/toast";
import { axiosWithAbort } from "../../services/axiosWithAbort";
import { buildCustomEFSharingPayload } from "../services/customEFSharing";

const baseURL = axiosInstance.defaults.baseURL;

export const emissionFactorManagementAPI = {
  //////// 取得自定義係數資料表
  async getCustomEFList(requestBody) {
    const response = await axiosWithAbort(`CustomEFList`, {
      method: "POST",
      url: `/api/custom/ef_list`,
      data: requestBody,
    });

    return response?.data;
  },

  async getCustomEFHistory(customEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/custom/history/${customEFId}`,
      );
      if (response.data?.success === false) {
        handleAPIError(null, { apiData: response.data });
      }
      return response.data?.data || [];
    } catch (err) {
      handleAPIError(err);
    }
  },

  async getSystemEFList(requestBody) {
    const response = await axiosWithAbort(`SystemEFList`, {
      method: "POST",
      url: `/api/ef/ef_list`,
      data: requestBody,
    });

    return response?.data;
  },
  //*****************************************///以上更新 */

  ////////拿到category
  async getCustomEFCatDropdown() {
    try {
      const response = await axiosInstance.get(`/api/custom/category/`);

      ////////轉成[{},{}]格式
      const data = Object.entries(response.data.data).map(([value, label]) => ({
        value,
        label,
      }));

      return data;
    } catch (err) {
      // handleAPIError(err, "Error fetching custom EF category");
      console.error("Error fetching custom EF category", err);
      return [];
    }
  },

  ////////取得自定義單位
  async getCustomUnitDropdown() {
    try {
      const response = await axiosInstance.get(`/api/custom/units/`);

      ////////轉成[{},{}]格式
      const data = Object.entries(response.data.data).map(([key, value]) => ({
        label: key, // 文字標籤
        value: value, // 物件值
      }));

      return data;
    } catch (err) {
      // handleAPIError(err, "Error fetching custom EF category");
      console.error("Error fetching custom EF category", err);
      return [];
    }
  },

  ////////新增自定義
  async addCustomEF(data, standardId, files = [], modeId = 1) {
    ////////必填檢查
    const validateField = (field, errorMessage) => {
      if (
        field === "" ||
        field === null ||
        field === undefined ||
        Number.isNaN(field)
      ) {
        handleAPIError(errorMessage, errorMessage);
      }
    };

    const isEmpty = (v) => v === undefined || v === null || v === "";

    ////////判斷有值的三個數
    const unitMap = {
      "CO₂": "co2EFValue",
      "CH₄": "ch4EFValue",
      "N₂O": "n2oEFValue",
      HFCs: "hfcsEFValue",
      PFCs: "pfcsEFValue",
      "SF₆": "sf6EFValue",
      "NF₃": "nf3EFValue",
      "CO₂e": "co2eEFValue",
    };

    ////////判斷式哪一個EF 例如CO2
    const firstKey = unitMap[data?.firstGHG];
    const secondKey = unitMap[data?.secondGHG];
    const thirdKey = unitMap[data?.thirdGHG];

    let mappingArr = [
      {
        key: firstKey,
        lower: data?.firstUncertainlyLower,
        upper: data?.firstUncertainlyUpper,
      },
      {
        key: secondKey,
        lower: data?.secondUncertainlyLower,
        upper: data?.secondUncertainlyUpper,
      },
      {
        key: thirdKey,
        lower: data?.thirdUncertainlyLower,
        upper: data?.thirdUncertainlyUpper,
      },
    ];

    ////////創建不確定性排序陣列

    const keyToIndex = {
      co2EFValue: 0,
      ch4EFValue: 1,
      n2oEFValue: 2,
    };

    const sortArr = [];

    mappingArr.forEach(({ key, lower, upper }) => {
      if (!key) return;

      const temp = { lower, upper };
      const index = keyToIndex[key] ?? 0; // 預設放到 index 0
      sortArr[index] = temp;
    });

    ////////過濾空的物件

    let filteredArr = sortArr.filter((obj) => Object.keys(obj).length > 0);

    const requestBody = {
      companyId: data?.companyId?.[0] || "",
      standardId: standardId || 1,
      year: Number(data.year),
      nameEF: data.name || "",
      category: data?.category || "",
      descEF: data.descEF || "",
      unitIdEF: data.unit?.id,
      unitIdEmission: Number(data.EFUnit),
      unitCategoryId: data.unit?.unitCategoryId,
      co2EFValue: null,
      ch4EFValue: null,
      n2oEFValue: null,
      hfcsEFValue: null,
      pfcsEFValue: null,
      sf6EFValue: null,
      nf3EFValue: null,
      co2eEFValue: null,
      hfcsGWP: Number(data.HFCsGWP) || 0,
      pfcsGWP: Number(data.PFCsGWP) || 0,
      isBiomass:
        data.biomass === "true"
          ? true
          : data.biomass === "false"
            ? false
            : null,
      calorificValue: data.calorificValue ?? null,
      calorificValueUnit: data.calorificValueUnit || "",
      calorificValueSourceDesc: data.calorificValueSourceDesc || "",
      carbonPercentage: data.carbonPercentage || 0,
      upperEF1: filteredArr[0]?.upper || 0,
      lowerEF1: filteredArr[0]?.lower || 0,
      upperEF2: filteredArr[1]?.upper || 0,
      lowerEF2: filteredArr[1]?.lower || 0,
      upperEF3: filteredArr[2]?.upper || 0,
      lowerEF3: filteredArr[2]?.lower || 0,
      // modeId: 1=一般多個檔案(最多5筆), 0=ZIP/RAR(僅1筆)，無檔案時固定給 1
      modeId: files && files.length > 0 ? Number(modeId) : 1,
      ...buildCustomEFSharingPayload(data),
    };

    if (firstKey) {
      requestBody[firstKey] = Number(data.firstFactorValue);
    }
    if (secondKey) {
      requestBody[secondKey] = Number(data.secondFactorValue);
    }
    if (thirdKey) {
      requestBody[thirdKey] = Number(data.thirdFactorValue);
    }

    // 檢查必填欄位

    validateField(requestBody.category, "The Category field cannot be empty!");

    validateField(
      requestBody.companyId,
      "The Select Company field cannot be empty!",
    );
    validateField(
      requestBody.nameEF,
      "The Emission Factor Name field cannot be empty!",
    );
    validateField(
      requestBody.year,
      "The Reference Year field cannot be empty!",
    );

    validateField(requestBody.unitIdEF, "The Base Unit field cannot be empty!");
    validateField(
      requestBody.unitIdEmission,
      "The Emission Factor Unit field cannot be empty!",
    );
    validateField(
      requestBody.descEF,
      "The Emission Factor Description field cannot be empty!",
    );
    validateField(requestBody.isBiomass, "The Biomass field cannot be empty!");

    if (!firstKey && !secondKey && !thirdKey) {
      handleAPIError(
        "Please fill in at least one GHG field.",
        "Please fill in at least one GHG field.",
      );
    }

    if (requestBody.calorificValue != null) {
      if (!requestBody.calorificValue) {
        handleAPIError(
          "The Calorific Value field cannot be empty!",
          "The Calorific Value field cannot be empty!",
        );
      }
      if (!requestBody.calorificValueUnit) {
        handleAPIError(
          "The Calorific Value Unit field cannot be empty!",
          "The Calorific Value Unit field cannot be empty!",
        );
      }
      if (!requestBody.calorificValueSourceDesc) {
        handleAPIError(
          "The Calorific Value Source Desc field cannot be empty!",
          "The Calorific Value Source Desc field cannot be empty!",
        );
      }
    }

    if (firstKey && isEmpty(requestBody[firstKey])) {
      handleAPIError(
        "Please fill in the corresponding Factor Value field.",
        "Please fill in the corresponding Factor Value field.",
      );
    }

    if (secondKey && isEmpty(requestBody[secondKey])) {
      handleAPIError(
        "Please fill in the corresponding Factor Value field.",
        "Please fill in the corresponding Factor Value field.",
      );
    }

    if (thirdKey && isEmpty(requestBody[thirdKey])) {
      handleAPIError(
        "Please fill in the corresponding Factor Value field.",
        "Please fill in the corresponding Factor Value field.",
      );
    }

    if (requestBody.hfcsEFValue && !requestBody.hfcsGWP) {
      handleAPIError(
        "Please fill in the corresponding GWP field.",
        "Please fill in the corresponding GWP field.",
      );
    }

    if (requestBody.pfcsEFValue && !requestBody.pfcsGWP) {
      handleAPIError(
        "Please fill in the corresponding GWP field.",
        "Please fill in the corresponding GWP field.",
      );
    }

    try {
      //////// 數量驗證
      if (files && files.length > 0) {
        if (Number(modeId) === 0 && files.length > 1) {
          handleAPIError(
            "ZIP/RAR mode only allows 1 file.",
            "ZIP/RAR mode only allows 1 file.",
          );
          return;
        }
        if (Number(modeId) === 1 && files.length > 5) {
          handleAPIError(
            "You can upload a maximum of 5 files.",
            "You can upload a maximum of 5 files.",
          );
          return;
        }
      }

      //////// 統一使用 FormData (multipart/form-data) 格式
      const formData = new FormData();
      // 格式：dto=(JSON字串), files=(binary)
      formData.append("dto", JSON.stringify(requestBody));

      // 如果有檔案則附加
      if (files && files.length > 0) {
        files.forEach((file) => formData.append("files", file));
      }

      const response = await axiosInstance.post(`/api/custom/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.data.success === false) {
        handleAPIError(null, {
          apiData: response.data,
        });
      } else {
        showSuccessToast({
          apiData: response.data,
          scenarioCode: MESSAGE_CODES.CUSTOM_EF_CREATE_SUCCESS,
        });
      }
      return response.data;
    } catch (err) {
      console.error("Error Adding custom EF", err);
      handleAPIError(err);
    }
  },

  ////////修改自定義
  async modifyCustomEF(id, data) {
    ////////判斷有值的三個數
    const unitMap = {
      "CO₂": "co2EFValue",
      "CH₄": "ch4EFValue",
      "N₂O": "n2oEFValue",
      HFCs: "hfcsEFValue",
      PFCs: "pfcsEFValue",
      "SF₆": "sf6EFValue",
      "NF₃": "nf3EFValue",
      "CO₂e": "co2eEFValue",
    };

    const firstKey = unitMap[data?.firstGHG];
    const secondKey = unitMap[data?.secondGHG];
    const thirdKey = unitMap[data?.thirdGHG];

    let mappingArr = [
      {
        key: firstKey,
        lower: data?.firstUncertainlyLower,
        upper: data?.firstUncertainlyUpper,
      },
      {
        key: secondKey,
        lower: data?.secondUncertainlyLower,
        upper: data?.secondUncertainlyUpper,
      },
      {
        key: thirdKey,
        lower: data?.thirdUncertainlyLower,
        upper: data?.thirdUncertainlyUpper,
      },
    ];

    ////////創建不確定性排序陣列

    const keyToIndex = {
      co2EFValue: 0,
      ch4EFValue: 1,
      n2oEFValue: 2,
    };

    const sortArr = [];

    mappingArr.forEach(({ key, lower, upper }) => {
      if (!key) return;

      const temp = { lower, upper };
      const index = keyToIndex[key] ?? 0; // 預設放到 index 0
      sortArr[index] = temp;
    });

    ////////過濾空的物件

    let filteredArr = sortArr.filter((obj) => Object.keys(obj).length > 0);

    const requestBody = {
      companyId: data?.companyId || "",
      standardId: data?.standardId,
      year: Number(data.year) || 0,
      nameEF: data.name || "",
      category: data.category.replace(".", "_") || "",
      descEF: data.descEF || "",
      unitIdEF: data.unit?.id || 0,
      unitIdEmission: Number(data.EFUnit),
      unitCategoryId: data.unit?.unitCategoryId || 0,
      co2EFValue: null,
      ch4EFValue: null,
      n2oEFValue: null,
      hfcsEFValue: null,
      pfcsEFValue: null,
      sf6EFValue: null,
      nf3EFValue: null,
      co2eEFValue: null,
      hfcsGWP: Number(data.HFCsGWP) || 0,
      pfcsGWP: Number(data.PFCsGWP) || 0,
      isBiomass:
        data.biomass === "true"
          ? true
          : data.biomass === "false"
            ? false
            : null,
      calorificValue: data.calorificValue ?? null,
      calorificValueUnit: data.calorificValueUnit || "",
      calorificValueSourceDesc: data.calorificValueSourceDesc || "",
      carbonPercentage: data.carbonPercentage || 0,
      upperEF1: filteredArr[0]?.upper || 0,
      lowerEF1: filteredArr[0]?.lower || 0,
      upperEF2: filteredArr[1]?.upper || 0,
      lowerEF2: filteredArr[1]?.lower || 0,
      upperEF3: filteredArr[2]?.upper || 0,
      lowerEF3: filteredArr[2]?.lower || 0,
      ...buildCustomEFSharingPayload(data),
    };

    if (firstKey) {
      requestBody[firstKey] = Number(data.firstFactorValue);
    }
    if (secondKey) {
      requestBody[secondKey] = Number(data.secondFactorValue);
    }
    if (thirdKey) {
      requestBody[thirdKey] = Number(data.thirdFactorValue);
    }

    if (requestBody.calorificValue != null) {
      if (!requestBody.calorificValue) {
        handleAPIError(
          "The Calorific Value field cannot be empty!",
          "The Calorific Value field cannot be empty!",
        );
      }
      if (!requestBody.calorificValueUnit) {
        handleAPIError(
          "The Calorific Value Unit field cannot be empty!",
          "The Calorific Value Unit field cannot be empty!",
        );
      }
      if (!requestBody.calorificValueSourceDesc) {
        handleAPIError(
          "The Calorific Value Source Desc field cannot be empty!",
          "The Calorific Value Source Desc field cannot be empty!",
        );
      }
    }

    try {
      const response = await axiosInstance.put(
        `/api/custom/${id}`,
        requestBody,
      );

      if (response.data?.success === false) {
        handleAPIError(null, { apiData: response.data });
      }
      return response.data;
    } catch (err) {
      console.error("Error Modifying custom EF", err);
      handleAPIError(err);
    }
  },

  ////////刪除自定義
  async deleteCustomCustomEF(id, cat) {
    const requestBody = {
      category: cat,
    };
    try {
      const response = await axiosInstance.delete(`/api/custom/${id}`, {
        data: requestBody,
      });

      // 檢查後端回應的 `success` 是否為 `false`
      if (response.data?.success === false) {
        handleAPIError(null, { apiData: response.data });
      }
      return response.data;
    } catch (err) {
      console.error("Error deleting Custom EF", err);
      handleAPIError(err);
    }
  },

  //////// 下載自定義 Excel
  async downloadCustomEFExcel(
    parentCId,
    companyIdArr,
    isParent,
    lang,
    standardId,
  ) {
    if (lang === "tw") {
      lang = "zh_tw";
    }
    const requestBody = {
      parent_company_id: parentCId,
      companyIds: companyIdArr,
      is_parent: isParent,
      lang: lang,
      standardId,
    };

    try {
      const response = await axiosInstance.post(
        `/api/custom/download-template/`,
        requestBody,
        {
          responseType: "blob", // 設定回應類型為 Blob，確保能接收二進制檔案
          timeout: 300000,
        },
      );

      // 創建 Blob 物件
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // 創建下載連結
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contentDisposition = response.headers["content-disposition"];
      const matchFileName = contentDisposition.match(/filename="?([^"]+)"?/);
      link.href = downloadUrl;
      link.setAttribute("download", `${matchFileName[1]}`); // 設定下載的檔名
      document.body.appendChild(link);
      link.click(); // 自動點擊下載
      document.body.removeChild(link); // 下載後移除連結
    } catch (err) {
      console.error("Error downloading custom Excel", err);
    }
  },

  ////////上傳Excel
  async uploadCustomEFExcel(parentCompanyId, file, lang) {
    if (lang === "tw") {
      lang = "zh_tw";
    }
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axiosInstance.post(
        `/api/custom/import-excel/${parentCompanyId}?lang=${lang}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // 確保 Content-Type 正確
          },
        },
      );

      // 顯示成功的 Toast
      if (response.data.success === false) {
        handleAPIError(null, {
          apiData: response.data
        });
      } else {
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.FILE_UPLOAD_SUCCESS,
        });
      }
      return response;
    } catch (err) {
      console.error("Error uploading Excel", err);
      // handleAPIError(err, "Upload fail !");
    }
  },

  ////////拿取平台資料庫列表
  async getSystemDatabaseList(cat, sourceEFId, unitIdEF, keyword, page) {
    const requestBody = {
      category: cat === "all" ? "" : cat,
      sourceEFId: Number(sourceEFId) || 0,
      unitIdEF: Number(unitIdEF) || 0,
      keyword: keyword,
      page: 1,
      pageSize: 999999,
    };
    try {
      const response = await axiosInstance.post(`/api/ef/ef_list`, requestBody);
      return response.data;
    } catch (err) {
      console.error("Error fetching platform EF list", err);
      // handleAPIError(err, "Error fetching platform EF list");
      return [];
    }
  },

  ////////平台資料庫排放係數來源下拉式選單
  async getSystemDatabaseSourceDropdownList(cat, standardId) {
    const requestBody = {
      category: cat || "",
      standardId,
    };

    try {
      const response = await axiosInstance.post(
        `/api/ef/source_dropdown_list`,
        requestBody,
      );
      return response.data.data;
    } catch (err) {
      console.error("Error fetching platform EF source list", err);
      // handleAPIError(err, "Error fetching platform EF source list");
      return [];
    }
  },

  ////////平台資料庫單位下拉式選單
  async getSystemDatabaseUnitDropdownList(cat, standardId) {
    const requestBody = {
      category: cat || "",
      standardId,
    };

    try {
      const response = await axiosInstance.post(
        `/api/ef/units_dropdown_list`,
        requestBody,
      );
      return response.data.data;
    } catch (err) {
      console.error("Error fetching platform EF unit list", err);
      // handleAPIError(err, "Error fetching platform EF unit list");
      return [];
    }
  },

  //////取得自定義佐證資料
  async getValidationFileAPI(customEFId) {
    try {
      const response = await axiosInstance.get(
        `/api/custom/validation_file/${customEFId}`,
        {
          headers: {
            accept: "application/json",
          },
        },
      );

      // 根據 API 實際回傳結構調整
      let fileList = response.data.data || response.data || [];

      // 在這裡添加基礎URL到每個檔案的link屬性
      fileList = fileList.map((file) => ({
        ...file,
        path: `${baseURL}${file.path}`,
      }));
      return fileList;
    } catch (error) {
      console.error("ValidationFileAPI error:", error);
      // handleAPIError(error, "ValidationFileAPI error");
    }
  },

  //////// 新增/編輯佐證資料
  async setValidationFileAPI(
    customEFId,
    companyId,
    modeId, // 多個檔案=1，zip=2
    filesId, // 如果該筆 dataEntryId 以前有上傳過檔案的話，要將檔案的 id 貼上
    files, // 檔案物件（File 或 File[]）
  ) {
    const formData = new FormData();
    formData.append("companyId", companyId);
    formData.append("modeId", modeId);
    formData.append("filesId", filesId || "");

    // 處理檔案上傳
    if (Array.isArray(files)) {
      files.forEach((file) => {
        formData.append("files", file); // 多個檔案用同一個 key
      });
    } else if (files) {
      formData.append("files", files); // 單個檔案
    }

    try {
      const response = await axiosInstance.post(
        `/api/custom/upload-files/${customEFId}`,
        formData,
        {
          headers: {
            // 下面这行“覆盖”掉全局的 application/json
            "Content-Type": "multipart/form-data",
          },
        },
      );
      assertAPIResponse(response);

      // 檢查回應是否成功
      if (response.status >= 200 && response.status < 300) {
      showSuccessToast({
        apiData: response.data,
        scenarioCode: MESSAGE_CODES.FILE_UPLOAD_SUCCESS,
        });
        return response.data.data || true; // 成功回傳資料或成功狀態
      } else {
        throw new Error(`API returned error status: ${response.status}`);
      }
    } catch (error) {
      handleAPIError(error);
      console.error("Error uploading validation file:", error);
    }
  },

  //預覽word
  async previewWordFileAPI(link) {
    try {
      // 如果 link 是 blob URL 或完整路徑，直接用 fetch 避免 axiosInstance baseURL 拼接錯誤
      if (link.startsWith("blob:") || link.startsWith("http")) {
        const res = await fetch(link);
        return await res.arrayBuffer();
      }

      // 否則使用系統配置的 axiosInstance
      const response = await axiosInstance(link, {
        method: "GET",
        responseType: "arraybuffer",
      });
      return response.data;
    } catch (error) {
      console.error("Error previewing word file:", error);
      throw error;
    }
  },

  ////////GWPList data
  async getGWPList() {
    const requestBody = {
      keyword: "",
      page: 1,
      pageSize: 999,
    };
    try {
      const response = await axiosInstance.post(
        `/api/gwpview/gwpView_list`,
        requestBody,
      );
      return response.data.data;
    } catch (err) {
      console.error("Error fetching GWP list", err);
      // handleAPIError(err, "Error fetching GWP list");
      return [];
    }
  },
};
